import React from 'react'
import { useAppSelector } from '../../../redux/hooks'
import { Product } from '../../../types/types'
import Spoiler from '../../Spoiler/Spoiler'

import './CategoryFilter.scss'

const CategoryFilter = (props: {applyAction: CallableFunction, products: Product[]}) => {
  const categories = useAppSelector((state) => state.categoryReducer)

  const handleCategory = (category: string) => {
    const arrayToReturn = props.products.filter(item => item.category.name === category)
    props.applyAction({name: category, products: arrayToReturn})
  }

  return (
    <div>
        <Spoiler title="Category" opened>
          <ul>
            {categories.map((item) => {
              return (
              <span key={item.id} onClick={() => handleCategory(item.name)} className="category-item">{item.name}</span>)
            })}
          </ul>
        </Spoiler>
    </div>
  )
}

export default CategoryFilter